import { useCallback, useRef } from "react";

/**
 * STRAŻNIK KOLEJNOŚCI ODPOWIEDZI — „odpowiedź, która przyszła później, ale dotyczy starszego pytania,
 * nie ma prawa nadpisać ekranu".
 *
 * <p><b>Zgłoszenie właściciela 2026-09-11:</b> „/itam/urzadzenia wyszukiwanie tabeli nie dziala,
 * dynamicznie, wcale nie dziala". Pole szukania było podpięte poprawnie — fraza schodziła do stanu,
 * stan do parametru `search`, serwer ten parametr stosował. Zawodziła KOLEJNOŚĆ.</p>
 *
 * <p><b>Zmierzony przebieg</b> (zapadka {@code pages/itam/__tests__/szukajkaItamA1.test.js}):
 * wejście na listę wysyła zapytanie BEZ frazy — czyli o całą ewidencję, z dociągnięciem faktur;
 * to najwolniejsze zapytanie tego ekranu. Zanim wróci, człowiek zdąży wpisać frazę i po opóźnieniu
 * leci drugie zapytanie — wąskie, więc szybkie. Wraca pierwsze jako drugie i wstawia do tabeli
 * PEŁNĄ listę, chociaż w polu stoi fraza. Na ekranie wygląda to dokładnie jak „szukajka nie działa":
 * lista mignie zawężona i wraca do stanu sprzed wpisania.</p>
 *
 * <p>Dlaczego licznik, a nie {@code AbortController}: przerwanie żądania zwalnia łącze, ale nie
 * rozwiązuje problemu — odpowiedź już w drodze i tak trafiłaby do {@code setState}. Liczy się
 * to, KTÓRE zapytanie jest ostatnie, a nie czy poprzednie da się zatrzymać.</p>
 *
 * <pre>
 * const zacznij = useNajnowszaOdpowiedz();
 * const wczytaj = useCallback(async () => {
 *     const aktualne = zacznij();
 *     const odp = await api.getCos(params);
 *     if (!aktualne()) return;   // starsze pytanie — wynik na śmietnik
 *     setDane(odp.data);
 * }, [zacznij, params]);
 * </pre>
 *
 * @returns {() => (() => boolean)} funkcja otwierająca żądanie; jej wynik odpowiada na pytanie
 *          „czy to nadal najnowsze żądanie?".
 */
export default function useNajnowszaOdpowiedz() {
    const licznik = useRef(0);

    return useCallback(() => {
        const moje = ++licznik.current;
        return () => moje === licznik.current;
    }, []);
}
